import { useEffect, useState } from 'react';
import { Loadable } from '@guest-widgets/shared/src/utils/loadable/loadable';
import { locationApi } from '@guest-widgets/shared/src/apis/guestExperience';
import {
  LocationSuggestionsDto,
  SuggestedLocationDto,
} from '@checkfront/guest-experience-api-api-client-javascript-axios';

import { useSettings } from '../../../settingsContext';

let isValidLocation = (location: SuggestedLocationDto) =>
  parseFloat(location.geolocation.latitude) !== 0 ||
  parseFloat(location.geolocation.longitude) !== 0;

const filterOutInvalidLocations = ({
  cities,
  regions,
  holidayRegions,
}: LocationSuggestionsDto): LocationSuggestionsDto => ({
  cities: cities.filter(isValidLocation),
  regions: regions.filter(isValidLocation),
  holidayRegions: holidayRegions.filter(isValidLocation),
});

export const useLocationSuggestions = (keyword: string) => {
  const { customerCode, locale } = useSettings();
  const [suggestions, setSuggestions] = useState<Loadable<LocationSuggestionsDto>>(
    Loadable.createEmpty<LocationSuggestionsDto>()
  );

  useEffect(() => {
    let isActive = true;

    if (keyword.length <= 2) {
      if (!suggestions.isEmpty) {
        setSuggestions(Loadable.createEmpty());
      }
      return;
    }

    (async () => {
      try {
        setSuggestions(Loadable.createLoading());
        const newSuggestions = await locationApi.getSuggestedLocation(
          customerCode,
          locale,
          keyword
        );

        if (isActive) {
          setSuggestions(Loadable.createValid(filterOutInvalidLocations(newSuggestions)));
        }
      } catch (exception) {
        setSuggestions(Loadable.createFailed(exception));
      }
    })();

    return () => {
      isActive = false;
    };
  }, [keyword]);

  return suggestions;
};
